import { NgRedux } from '@angular-redux/store';
import { IAppState } from '@app/store';
import { rx } from '@app/shared/rx';
import { isUndefined, get } from 'lodash';
import { Injectable } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';

@Injectable()
export class BaseApiActions {
  public constructor(public ngRedux: NgRedux<IAppState>) {}

  public resultAsPromised(requestId): Promise<any> {
    const selectionPath: string[] = ['tools', 'operationResult'];

    return this.ngRedux
      .select(selectionPath)
      .pipe(
        rx.find(
          (result: any) => get(result, 'options.requestId') === requestId,
        ),
      )
      .toPromise()
      .then((operationResult: any): any => {
        if (!operationResult || isUndefined(operationResult.response)) {
          return {
            errors:
              get(operationResult, 'errors', operationResult) ||
              I18n.Common.UnhandledError,
          };
        }

        return operationResult.response;
      });
  }
}
